import { Icon, Navbar } from '@codeparva/ui-components-library';
import React from 'react';
import { NavBarTypes } from '../NavBar';
import { FontAwesomeIcon } from '../../../../utilities/iconLoader/FontAwesomeIcon';
import { TopBarTypes } from '../TopBar';
import { useThemeContext } from './hooks/themeContext';
import { weakKey } from '../../../../utilities/weakKey';
import { HEADER_ICON_SIZES } from '../Header/constants';

export const NavBarSocialMediaIcons = ({
  socialIconsandUrls,
  handlenavbarBurgerState,
  openNavBar,
}: NavBarTypes.TSocialIconsAndState) => {
  const currTheme = useThemeContext();
  const iconsArray: JSX.Element[] = [];
  const MediaIcons = socialIconsandUrls.socialIcons;

  const socialMediaIcons = (
    socialIconClassName: string,
    iconsUrl: string,
    socialMediaIcon: React.ReactNode
  ) => {
    return (
      <Icon size="medium" className={socialIconClassName}>
        <a
          href={iconsUrl}
          className={`is-flex has-text-${
            currTheme === 'dark' ? 'secondary' : 'primary'
          }
          ${openNavBar ? 'is-active' : ''}`}
          onClick={handlenavbarBurgerState}
        >
          {socialMediaIcon}
        </a>
      </Icon>
    );
  };
  const renderSocilaMediaIcons = () => {
    if (MediaIcons) {
      const iconsData = MediaIcons;
      iconsData.forEach((icon: TopBarTypes.TIconsType) => {
        {
          iconsArray.push(
            <Navbar.Item
              href={icon.iconsUrl}
              renderAs="div"
              key={weakKey(icon)}
              className={
                MediaIcons === undefined
                  ? 'socialMediaIconsInActive has-text-primary'
                  : 'socialMediaIconsActive has-text-primary'
              }
            >
              {socialMediaIcons(
                icon.iconName,
                icon.iconsUrl,
                <FontAwesomeIcon
                  iconClassName={icon.iconName}
                  iconContextProps={{
                    style: {
                      fontSize: HEADER_ICON_SIZES.socialiconSize,
                    },
                  }}
                />
              )}
            </Navbar.Item>
          );
        }
      });
    }
    return iconsArray;
  };

  if (MediaIcons) {
    return (
      <>
        {MediaIcons.length > 0 ? (
          <div
            className={`socialMediaDiv is-flex flex-direction-row is-justify-content-center cp-section-bg-${
              currTheme === 'dark' ? 'dark' : 'light'
            }`}
          >
            {renderSocilaMediaIcons()}
          </div>
        ) : (
          ''
        )}
      </>
    );
  } else {
    return <></>;
  }
};

export default NavBarSocialMediaIcons;
